module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "PageTitle",
    class: _vm.pageTitleClasses
  }, [_c('div', {
    staticClass: "PageTitle-lock"
  }, [(_vm.lock) ? _c('icon', {
    staticClass: "PageTitle-lockIcon",
    attrs: {
      "name": "lock",
      "width": "18px",
      "height": "18px"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('h1', {
    staticClass: "PageTitle-title",
    domProps: {
      "innerHTML": _vm._s(_vm.resolvedTitle)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-771bedda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTitle.vue
// module id = 780
// module chunks = 1474